import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = ['litigant--litigant-request-management-cancel-request-modal'];

    connect() {
        // Auto-open the cancellation modal when the litigant lands on the page
        // from the "Cancel my request" CTA in their notification email.
        // The email URL helper appends a `#openCancel` hash fragment (kept out
        // of the query string so it does not invalidate the Symfony UriSigner
        // signature). For safety we also accept a legacy `?openCancel=1` query
        // marker. Either form is stripped from the URL after opening so a page
        // refresh does not re-open the modal.
        this.pendingAutoOpen = this.shouldAutoOpenModal();
        this.tryAutoOpen();
    }

    // Stimulus invokes this when the outlet controller registers. Both this
    // controller and the modal controller are lazy-fetched, so the outlet may
    // connect AFTER our own connect() ran. We must not rely on a one-shot
    // queueMicrotask check.
    litigantLitigantRequestManagementCancelRequestModalOutletConnected() {
        this.tryAutoOpen();
    }

    tryAutoOpen() {
        if (!this.pendingAutoOpen) {
            return;
        }
        if (!this.hasLitigantLitigantRequestManagementCancelRequestModalOutlet) {
            return;
        }
        this.pendingAutoOpen = false;
        this.litigantLitigantRequestManagementCancelRequestModalOutlet.openModal();
        this.stripAutoOpenMarkerFromUrl();
    }

    openModal(event) {
        event.preventDefault();

        this.litigantLitigantRequestManagementCancelRequestModalOutlet.openModal();
    }

    shouldAutoOpenModal() {
        const params = new URLSearchParams(window.location.search);

        return '1' === params.get('openCancel') || '#openCancel' === window.location.hash;
    }

    stripAutoOpenMarkerFromUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('openCancel');
        if ('#openCancel' === url.hash) {
            url.hash = '';
        }
        window.history.replaceState({}, '', url.toString());
    }
}